import { LinkRounded } from "@mui/icons-material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { BaseModuleSubtype, Subtype } from "./subtype";
import { LinkServiceModuleEditor } from "../../../components/actionModules/subtypes/link/LinkServiceModuleEditor";
import { LinkEditorPreview } from "../../../components/actionModules/subtypes/link/LinkEditorPreview";

export const LinkSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.link.name",
    type: Subtype.LinkModuleSubtype,
    icon: <LinkRounded />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<LinkRounded />}
        name="actionModules.subtypes.link.name" />,
    editorPreview: LinkEditorPreview,
    editableProperties: [
        {
            name: "buttonName",
            displayName: "actionModules.subtypes.link.buttonName",
            propertyType: PropertyTypes.text
        },
        {
            name: "url",
            displayName: "actionModules.subtypes.link.url",
            propertyType: PropertyTypes.text
        },
        {
            name: "serviceModuleId",
            displayName: "actionModules.subtypes.link.serviceModule",
            propertyType: PropertyTypes.complex,
            editor: LinkServiceModuleEditor,
        },
    ]
};

export interface LinkSubtypeResponse extends BaseModuleSubtype {
    buttonName: string | null;
    url: string | null;
    serviceModuleId: number | null;
};